export interface ShareItem {
  mode: ShareMode;
  name: string;
  icon: string;
}

export enum ShareMode {
  Email = 'email',
  Teams = 'teams',
}

export const ICONS = {
  HOME: {
    name: 'Home',
    icon: 'icon-home',
  },
  NAVIGATION: {
    name: 'Navigation',
    icon: 'icon-areas',
    iconSelected: 'icon-areas-selected',
  },
  FAVORITE: {
    name: 'My Favorites',
    icon: 'icon-not-marked',
    iconSelected: 'icon-marked',
  },
  GO_BACK: {
    name: 'Back',
    icon: 'icon-arrow-back',
  },
  SCREENSHOT_ICONS: {
    name: 'Share',
    icon: 'icon-share',
    iconSelected: 'icon-share-selected',
  },
  HIGHLIGHT_ICONS: {
    name: 'Highlight',
    icon: 'icon-highlight',
    iconSelected: 'icon-highlight-selected',
  },
  RESET: {
    name: 'Reset',
    icon: 'icon-refresh',
  },
  FILTERS: {
    name: 'Filters',
    icon: 'icon-filters',
    iconSelected: 'icon-filters-selected',
  },
  NEWS: {
    name: 'News',
    icon: 'icon-menu-book',
    iconSelected: 'icon-menu-book-selected',
  },
  INSIGHTS: {
    name: 'Insights',
    icon: 'icon-insights',
    iconSelected: 'icon-insights-selected',
  },
};

export const SHARE_ITEMS: ShareItem[] = [
  {
    mode: ShareMode.Email,
    name: 'Email',
    icon: 'icon-outlook',
  },
];

export const OAUTH_SHARE_ITEMS: ShareItem[] = [
  {
    mode: ShareMode.Email,
    name: 'Email',
    icon: 'icon-outlook',
  },
  {
    mode: ShareMode.Teams,
    name: 'Teams',
    icon: 'icon-teams',
  },
];
